import { coversCourses, coversLiving } from '../../../../../utilities/sponsors';

type Fields = {
  scholarshipName: string;
  sponsorshipCovers: Array<string>;
  courseFundType: string;
  courseFundPercentage: number;
  courseFundAmount: number;
  livingFundType: string;
  livingFundPercentage: number;
  livingFundAmountType: string;
  livingFundAmount: number;
  courseAndLivingFundSeparate?: boolean;
  courseAndLivingFundType: string;
  courseAndLivingFundPercentage: number;
  courseAndLivingFundAmount: number;
};

type Visible = Record<
  'scholarshipName' | 'fundingCover' | 'courseForm' | 'livingForm' | 'courseAndLivingForm',
  boolean
>;

function courseFundComplete(fields: Fields) {
  const { courseFundType, courseFundPercentage, courseFundAmount } = fields;

  if (courseFundType === '') return false;
  if (courseFundType === 'Percentage' && courseFundPercentage === 0) return false;
  if (courseFundType === 'Amount' && courseFundAmount === 0) return false;

  return true;
}

function livingFundComplete(fields: Fields) {
  const { livingFundType, livingFundPercentage, livingFundAmountType, livingFundAmount } = fields;

  if (livingFundType === '') return false;
  if (livingFundType === 'Percentage' && livingFundPercentage === 0) return false;
  if (livingFundType === 'Amount') {
    if (livingFundAmountType === '') return false;
    if (livingFundAmount === 0) return false;
  }

  return true;
}

function courseAndLivingFundComplete(fields: Fields) {
  const { courseAndLivingFundType, courseAndLivingFundPercentage, courseAndLivingFundAmount } = fields;

  if (courseAndLivingFundType === '') return false;
  if (courseAndLivingFundType === 'Percentage' && courseAndLivingFundPercentage === 0) return false;
  if (courseAndLivingFundType === 'Amount' && courseAndLivingFundAmount === 0) return false;

  return true;
}

export function getPageStatus(fields: Fields): {
  complete: boolean;
  visible: Visible;
} {
  const { scholarshipName, sponsorshipCovers, courseAndLivingFundSeparate } = fields;

  const complete: boolean = (() => {
    if (scholarshipName === '') return false;

    if (coversCourses(sponsorshipCovers) && coversLiving(sponsorshipCovers)) {
      if (courseAndLivingFundSeparate === true) {
        if (courseFundComplete(fields) === false) return false;
        if (livingFundComplete(fields) === false) return false;
      } else if (courseAndLivingFundSeparate === false) {
        if (courseAndLivingFundComplete(fields) === false) return false;
      } else {
        return false;
      }
    } else if (coversCourses(sponsorshipCovers)) {
      if (courseFundComplete(fields) === false) return false;
    } else if (coversLiving(sponsorshipCovers)) {
      if (livingFundComplete(fields) === false) return false;
    } else {
      return false;
    }

    return true;
  })();

  const visible: Visible = {
    scholarshipName: true,
    fundingCover: true,
    courseForm: coversCourses(sponsorshipCovers) && !coversLiving(sponsorshipCovers),
    livingForm: !coversCourses(sponsorshipCovers) && coversLiving(sponsorshipCovers),
    courseAndLivingForm: coversCourses(sponsorshipCovers) && coversLiving(sponsorshipCovers),
  };

  return {
    complete,
    visible,
  };
}
